import config from "../config";
import { getTransformedElement } from "./getTransformedElement";

export const getElementRotations = (
  element,
  currentShape,
  canvasTop,
  canvasLeft,
  canvasRight,
  canvasBottom,
  tileGap
) => {
  const { offsetX, offsetY } = getTransformedElement(element);
  const defaultRatio = config.defaultRatio;
  const gap = config.defaultCanvasGap / defaultRatio + tileGap / defaultRatio;
  let rotation = config.defaultRotation;
  const positionX = element.x() - offsetX;
  const positionY = element.y() - offsetY;
  const width = element.width();
  const height = element.height();

  element.offset({
    x: width / 2,
    y: height / 2,
  });

  if (positionX <= gap + defaultRatio) {
    // left edge
    rotation = 90;
  // } else if (positionY <= gap * 2  + defaultRatio ) {
  } else if (positionY <= gap  + defaultRatio ) {
    // top edge
    rotation = 180;
  } else if (
    element.x() >= canvasTop - gap - defaultRatio - offsetX &&
    currentShape !== "right"
  ) {
    // on the horizontal tile and right edge
    rotation = 270;
  } else if (
    element.y() - offsetY + gap + defaultRatio > canvasRight &&
    element.x() + offsetX + gap + defaultRatio >= canvasBottom &&
    currentShape === "left"
  ) {
    // Below the horizontal tile and right edge
    rotation = -90;
  } else if (
    element.x() >= canvasTop - gap - defaultRatio - offsetX &&
    currentShape === "right"
  ) {
    // on the horizontal tile and right edge
    rotation = 270;
  } else if (
    element.y() - offsetY + gap + defaultRatio > canvasLeft &&
    element.x() - offsetX - gap - defaultRatio <= canvasBottom &&
    currentShape === "right"
  ) {
    // Below the horizontal tile and right edge
    rotation = 90;
  } else {
    rotation = 0;
  }

  return element.rotation(rotation);
};
